import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import MessageView from '../views/MessageView.vue'
import OrchardView from '../views/OrchardView.vue'
import { getToken } from '@/utils/token'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/message',
    name: 'message',
    component: MessageView
  },
  {
    path: '/orchard',
    name: 'orchard',
    component: OrchardView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局路由守卫：只用token判断登录状态
router.beforeEach((to, from, next) => {
  const hasToken = !!getToken()
  if (to.name !== 'login' && !hasToken) {
    next({ name: 'login' })
  } else if (to.name === 'login' && hasToken) {
    next({ name: 'home' })
  } else {
    next()
  }
})

export default router
